import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { useAuthStore } from '@/store/auth'
import AccessHelper from '@/lib/utils/AccessHelper'

export function useAccess() {
  const user = useAuthStore((state) => state.user)
  const { pathname } = useLocation()

  const userRoutes = useMemo(() => {
    return (user?.user_routes || []) as any[]
  }, [user?.user_routes])

  const accessHelper = useMemo(() => {
    return new AccessHelper(user, userRoutes)
  }, [user, userRoutes])

  return accessHelper
}

export function useAccessCheck(pathname?: string) {
  const accessHelper = useAccess()
  const { pathname: currentPathname } = useLocation()

  return useMemo(() => {
    return accessHelper.hasAccess(pathname || currentPathname)
  }, [accessHelper, pathname, currentPathname])
}


